import React from "react";

export type PillOption = { label: string; value: string };

type PillTabsProps = {
  options: PillOption[];
  value: string;
  onChange: (val: string) => void;
  className?: string;
  appearance?: "dark" | "light";
};

const PillTabs: React.FC<PillTabsProps> = ({ options, value, onChange, className, appearance = "dark" }) => {
  return (
    <div className={`flex flex-wrap gap-3 ${className || ""}`}>
      {options.map((op) => {
        const active = op.value === value;
        const darkCls = active
          ? "bg-blue-600 text-white"
          : "bg-neutral-700 text-white hover:bg-neutral-600";
        const lightCls = active
          ? "bg-blue-600 text-white border-blue-600"
          : "bg-white text-gray-700 border border-gray-300";
        return (
          <button
            key={op.value}
            onClick={() => onChange(op.value)}
            className={`px-5 py-1.5 rounded-full text-sm font-medium transition-colors focus:outline-none shadow-sm ${
              appearance === "dark" ? darkCls : lightCls
            }`}
          >
            {op.label}
          </button>
        );
      })}
    </div>
  );
};

export default PillTabs;


